import React from 'react';
import { Redirect } from 'react-router';

import StepperForm from './StepperForm';

export default class StepsForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeStep: props.first,
            init: { ...props.values },
            values: { ...props.values },
            changes: [],
            message: {},
            errors: {},
            redirect: '',
        };
        this.mounted = false;
    }
    setActiveStep(activeStep) {
        this.setState({ activeStep });
    }
    setMessage(content = '', type = 'info') {
        const message = content ? { content, type } : {};
        this.setState({ message });
    }
    setErrors(errors) {
        this.setState({ errors });
    }
    setError(error) {
        this.setState({ errors: { ...this.state.errors, ...error } });
    }
    getStepBag() {
        return {
            ...this.state,
            ...this.getStepActions(),
            extra: { ...(this.props.extra || {}) },
        };
    }
    getStepActions() {
        return {
            onSave: this.onSave,
            goNext: this.goNext,
            goBack: this.goBack,
            setNext: this.setNext,
            onChange: this.onChange,
            onError: this.onError,
            onReset: this.onReset,
            onCancel: this.onCancel,
            setValues: this.setValues,
            setInitValues: this.setInitValues,
            redirectTo: this.redirectTo,
        };
    }
    setInitValues = values => {
        this.setState({
            values,
            init: { ...values },
        });
    };
    setValues = values => {
        this.setState({ values });
    };
    goNext = () => {
        return this.goto('next');
    };
    goBack = () => {
        return this.goto('back');
    };
    goto = async direction => {
        const { activeStep, values, changes } = this.state;
        const step = this.props.steps[activeStep];
        const errors =
            direction === 'next' && step.validate
                ? (await step.validate(values, {}, changes)) || {}
                : {};
        let isValid = Object.keys(errors).length === 0;
        if (isValid) {
            if (typeof step[direction] === 'function') {
                this.onChange('loading', true);
                try {
                    isValid = await step[direction](this.getStepBag());
                } finally {
                    if (this.mounted) {
                        this.onChange('loading', false);
                    }
                }
            } else {
                this.setActiveStep(step[direction]);
            }
        } else {
            this.setErrors(errors);
        }
        return !!isValid;
    };
    async addLoading(result) {
        this.onChange('loading', true);
        try {
            return await result;
        } finally {
            if (this.mounted) {
                this.onChange('loading', false);
            }
        }
    }
    setNext = name => {
        this.setActiveStep(name);
    };
    onChange = (name, value) => {
        const { values } = this.state;
        const obj = typeof name == 'string' ? { [name]: value } : name;
        const changes = this._getChanges(obj);
        this.setState({
            changes,
            values: { ...values, ...obj },
        });
    };
    onError = (error = 'Something is wrong. Please try again.') => {
        if (typeof error === 'object') {
            this.setErrors(error);
        } else {
            this.setMessage(error, 'error');
        }
    };
    onSuccess(content) {
        this.setMessage(content, 'success');
    }
    onCancel = () => {
        this.setState({
            values: { ...this.state.init },
            changes: [],
            errors: {},
            message: {},
        });
    };
    onReset = () => {
        const { init, values } = this.state;
        const newInit = Object.keys(init).reduce((obj, name) => {
            obj[name] = values[name];
            return obj;
        }, {});
        this.setState({
            init: newInit,
            values: newInit,
            changes: [],
            errors: {},
            message: {},
        });
    };
    onSave = (...args) => {
        return this.props.onSave(...args);
    };
    redirectTo = redirect => {
        this.setState({ redirect });
    };
    componentDidMount() {
        this.mounted = true;
        const { activeStep } = this.state;
        const step = this.props.steps[activeStep];
        if (step.update) {
            const bag = this.getStepBag();
            const result = step.update(bag);
            this.addLoading(result);
        }
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    _getChanges(values) {
        const { init, changes } = this.state;
        const buff = new Set(changes);
        for (const [name, value] of Object.entries(values)) {
            if (typeof init[name] !== 'undefined') {
                if (init[name] !== value) {
                    buff.add(name);
                } else {
                    buff.delete(name);
                }
            }
        }
        return Array.from(buff);
    }
    render() {
        const { activeStep, redirect } = this.state;
        const step = this.props.steps[activeStep];
        const StepComponent = step.component;
        const bag = this.getStepBag();
        if (step.render) {
            setTimeout(() => step.render(bag));
        }
        if (redirect) {
            console.log(`StepsForm :: Redirect to: ${redirect}`);
            return <Redirect to={redirect} />;
        }
        console.log(`StepsForm :: Step: ${activeStep}`);

        const keys = Object.keys(this.props.steps);
        const steps = Object.values(this.props.steps);
        const labels = steps.map(step => step.label).filter(label => label);
        const stepNumber = keys.indexOf(activeStep);
        const stepper = labels.length ? (
            <StepperForm labels={labels} active={stepNumber} />
        ) : null;
        return (
            <React.Fragment>
                {stepper}
                <StepComponent {...bag} />
            </React.Fragment>
        );
    }
}
